import { breakpointUp } from 'src/utils/styled'
import styled, { css } from 'styled-components/macro'
import { ifProp } from 'styled-tools'

const StyledContainer = styled.div<{ wide: boolean }>`
    margin-top: ${({ theme }) => theme.spacing(2)};
    margin-right: auto;
    margin-left: auto;

    max-width: 95%;

    ${ifProp(
        'wide',
        css`
            max-width: 95%;
            @media (min-width: 2000px) {
                max-width: 1700px;
            }
        `,
        css`
            ${breakpointUp('lg')} {
                max-width: 75%;
            }
            @media (min-width: 2000px) {
                max-width: 1300px;
            }
        `,
    )}
`

interface RouteContainerProps {
    wide?: boolean
    children: React.ReactNode
}

export default function RouteContainer({ wide = false, children }: RouteContainerProps) {
    return <StyledContainer wide={wide}>{children}</StyledContainer>
}
